import React, { forwardRef } from 'react';
import BaseTooltip from '@mui/material/Tooltip';

import { mergeWithTwcn } from '@lyearn/style';

import { popperStyles } from './styles';
import { TooltipProps } from './types';

const DEFAULT_CLASSES = {
  arrow: 'text-bg-highlight before:ring-1 before:ring-text-info',
  popper: popperStyles,
  tooltip: `rounded-8 px-12 py-8 bg-bg-highlight body-short-03 text-text-white max-w-[25.6rem] ring-1 ring-text-info`,
};

const POPOVER_CLASSES = {
  tooltip: `rounded px-12 py-8 bg-bg-primary body-short-03 text-text-primary shadow-02 border border-border`,
};

const Tooltip = forwardRef<unknown, TooltipProps>((props, ref) => {
  const { classes: classesProp, placement = 'top', variant = 'default', ...rest } = props;

  const isDefaultVariant = variant === 'default';
  const classes = mergeWithTwcn(isDefaultVariant ? DEFAULT_CLASSES : POPOVER_CLASSES, classesProp);

  return (
    <BaseTooltip
      ref={ref}
      arrow={isDefaultVariant}
      classes={classes}
      enterDelay={400}
      placement={placement}
      {...rest}
    />
  );
});

export default Tooltip;
